import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useUserWithProfileQuery } from '@uplift/queries';


const useStyles = makeStyles({ name: 'InCallNoUpcomingSessionsWithCareTeam' })(theme => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: '18px',
  }
}));


export const InCallNoUpcomingSessionsWithCareTeam: React.VFC<{ patientId: string }> = ({ patientId }) => {
  const { classes } = useStyles();
  const { data: patient } = useUserWithProfileQuery(patientId, { suspense: true });

  return (
    <Box className={classes.root}>
      <Box>
        <Typography className={classes.title}>Next session with care team</Typography>
      </Box>
      <Box mt={2}>
        <Typography>{patient?.profile?.preferredName || patient?.user?.firstName} has no upcoming sessions with another provider</Typography>
      </Box>
    </Box>
  );
};
